import React from 'react';
import { Checkbox, Grid } from 'semantic-ui-react';
import { SlideDown } from 'react-slidedown';
import { connect } from 'react-redux';
import { find, isNil, sortBy } from 'lodash';
import SortingBox from '../SortingBox';
import ReorderTool from '../ReorderTool';

import {
  setActiveEventId,
  eventsSortingDownHandler,
  eventsSortingUpHandler
} from '../../../data/analysis/eventsActions';

class EventsBox extends SortingBox {
  constructor(props) {
    super(props);

    this.state = {
      hidden: true
    };

    this.setVisibleSection = this.setVisibleSection.bind(this);

    this.upHandler = this.upHandler.bind(this);
    this.downHandler = this.downHandler.bind(this);
    this.clearHandler = this.clearHandler.bind(this);
  }

  setVisibleSection() {
    this.setState(prevState => ({
      hidden: !prevState.hidden
    }));
  }

  upHandler() {
    this.props.dispatch(eventsSortingUpHandler());
  }

  downHandler() {
    this.props.dispatch(eventsSortingDownHandler());
  }

  clearHandler() {
    this.props.dispatch(setActiveEventId(null));
  }

  setActiveEvent(id) {
    this.props.dispatch(setActiveEventId(id));
  }

  render() {
    const sliderState = !this.props.layer && this.state.hidden;

    return (
      <div className="configurationBox">
        <Grid>
          <Grid.Row className="parameterHeader">
            <Grid.Column width={2} className="stepBox">
              4
            </Grid.Column>
            <Grid.Column width={12}>Events</Grid.Column>
            <Grid.Column width={2} className={`toggle ${this.state.hidden ? 'closed' : ''}`}>
              <i className="icon icon-play3 clickable" onClick={this.setVisibleSection} />
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <ReorderTool
          upHandler={this.upHandler}
          downHandler={this.downHandler}
          clearHandler={this.clearHandler}
        />
        <SlideDown closed={sliderState} className="boxContent">
          <Grid className="layersList eventsList">
            {sortBy(this.props.events, event => {
              return this.props.eventsSorting.indexOf(event.id);
            }).map(item => {
              let constructClassName = 'layer clickable';
              constructClassName += this.props.activeEventId === item.id ? ' active' : '';

              return (
                <Grid.Row
                  className={constructClassName}
                  key={item.id}
                  onClick={() => {
                    this.setActiveEvent(item.id);
                  }}
                >
                  <Grid.Column width={3}>
                    <i className="icon icon-Events" />
                  </Grid.Column>
                  <Grid.Column width={10}>{item.name}</Grid.Column>
                  <Grid.Column width={3} className="checkboxContainer">
                    <Checkbox />
                  </Grid.Column>
                </Grid.Row>
              );
            })}
          </Grid>
        </SlideDown>
      </div>
    );
  }
}

export default connect(state => ({
  layer: (() => {
    const { activeLayerId } = state.analysis.single;
    return find(state.analysis.single.layers, { id: activeLayerId });
  })(),
  events: state.analysis.single.events,
  activeEventId: state.analysis.single.activeEventId,
  eventsSorting: (() => {
    const { activeLayerId } = state.analysis.single;
    if (isNil(activeLayerId) || !(activeLayerId in state.analysis.single.eventsSorting)) {
      return [];
    }
    return state.analysis.single.eventsSorting[activeLayerId];
  })(),
  activeLayerId: state.analysis.single.activeLayerId
}))(EventsBox);



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/analysis/parameters/EventsBox.js